import React from "react";
import loadable from "@loadable/component";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import StatusIcon from "../../Icons/StatusIcon";
import useGetHook from "../../customHooks/useGetHook";
import APIS from "../../constant/Endpoint";
import Spinner from "../../Components/Reusable/Spinner";
import useDeleteHook from "../../customHooks/useDeleteHook";
import usePatchHook from "../../customHooks/usePatchHook";

const WizardListComponent = loadable(
  () => import("../../Components/Wizard/WizardList")
);
const WizardList = () => {
  const { data, isLoading } = useGetHook({
    queryKey: ["wizard"],
    url: `${APIS.FORM}`,
    params: {
      form_type: "wizard",
      limit: 10,
      offset: 0,
    },
  });
  const { mutateAsync } = useDeleteHook({
    queryKey: ["form_data"],
    navigateURL: "",
  });
  const handleDelete = async (setIsOpen: any, id: any) => {
    const url = `${APIS.FORM_DATA}${id}/`;
    try {
      const res = await mutateAsync({ url });
      if (res?.status === 204) {
        setIsOpen(false);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const { mutateAsync: patchUser } = usePatchHook({
    queryKey: ["wizard"],
    navigateURL: null,
  });
  const handleToggle = async (value: boolean, id: any, key: string) => {
    let payload = {};
    payload[key] = value;
    const url = `${APIS.FORM}${id}/`;
    const formData = payload;
    try {
      await patchUser({ url, formData });
    } catch (e) {
      console.log(e);
    }
  };
  return (
    <>
      <>
        <div
          className={tw`w-full flex justify-left gap-x-2 uppercase font-extrabold items-center`}
        >
          <StatusIcon />
          <span className={tw`text-[#5E5757] font-bold text-xl`}>Wizard</span>
        </div>
        {isLoading ? (
          <Spinner />
        ) : (
          <WizardListComponent
            data={data}
            handleDelete={handleDelete}
            handleToggle={handleToggle}
          />
        )}
      </>
    </>
  );
};

export default WizardList;
